/* MT/26 motion and small interactions.
   1. Marks hero slides and tab panels that become active after the first paint,
      so entrance animations never run on page load (keeps LCP untouched).
   2. Collection pages: shows the collection description in the banner, under the title,
      clamped with a "Show more" toggle. The text stays in the page HTML in full.
   3. Blocks with a photo and a link: a click on the photo follows the link.
   4. Accessibility helpers: spoken names for form fields, announced form errors,
      readable labels and a focus ring in the reviews and chat widgets. */
(function () {
  'use strict';
  function watch(root, selector, isOn) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        var el = m.target;
        if (!el.matches || !el.matches(selector)) return;
        if (isOn(el)) { if (!el.classList.contains('mt-anim')) el.classList.add('mt-anim'); }
        else if (el.classList.contains('mt-anim')) el.classList.remove('mt-anim');
      });
    }).observe(root, { attributes: true, attributeFilter: ['class', 'hidden'], subtree: true });
  }

  function collectionDescription() {
    var seo = document.querySelector('.mt-coll__seo');
    var desc = seo && seo.querySelector('.mt-coll__desc--bottom');
    var head = document.querySelector('.mt-coll__banner-head');
    if (!desc || !head || head.querySelector('.mt-coll__desc')) return;
    var old = seo.querySelector('.mt-readmore-btn');
    if (old) old.remove();
    desc.removeAttribute('data-mt-readmore');
    desc.classList.remove('mt-coll__desc--bottom', 'mt-expanded');
    desc.classList.add('mt-cdesc');
    desc.id = desc.id || 'mt-collection-description';
    head.appendChild(desc);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mt-cdesc__more';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', desc.id);
    btn.textContent = 'Show more';
    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('mt-is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : 'Show more';
    });
    head.appendChild(btn);
    if (desc.scrollHeight <= desc.clientHeight + 4) { btn.hidden = true; desc.classList.add('mt-is-open'); }
    if (seo.querySelector('.mt-coll__related')) seo.classList.add('mt-coll__seo--links');
    else seo.hidden = true;
  }

  var MEDIA = '.mt-fstory__media, .mt-story__media, .mt-lcc__img';
  var BOX = '.mt-fstory, .mt-story, .mt-lcc__col';
  function linkFor(media) {
    var box = media.closest(BOX);
    var a = box && box.querySelector('a[href]');
    return a && a.getAttribute('href') !== '#' ? a : null;
  }
  function clickablePhotos() {
    document.querySelectorAll(MEDIA).forEach(function (m) {
      if (!m.closest('a') && linkFor(m)) m.setAttribute('data-mt-go', '');
    });
    document.addEventListener('click', function (e) {
      var m = e.target.closest ? e.target.closest('[data-mt-go]') : null;
      if (!m || e.target.closest('a, button, video, iframe')) return;
      var a = linkFor(m);
      if (!a) return;
      if (e.metaKey || e.ctrlKey) window.open(a.href, '_blank', 'noopener');
      else window.location.href = a.href;
    });
  }

  /* Forms: every field gets a spoken name; error and success messages are announced to screen readers (WCAG 1.3.1, 3.3.1, 4.1.3).
     Works on the hand-coded forms too (warranty, VIP reward, NPS, returns), without touching their markup. */
  function formsA11y() {
    var root = document.getElementById('content');
    if (!root) return;
    root.querySelectorAll('input:not([type="hidden"]):not([type="submit"]):not([type="button"]), select, textarea').forEach(function (f) {
      if (f.getAttribute('aria-label') || f.getAttribute('aria-labelledby') || f.closest('label')) return;
      if (f.id && root.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(f.id) : f.id) + '"]')) return;
      var name = f.getAttribute('placeholder') || f.getAttribute('title') || '';
      if (!name) {
        var wrap = f.closest('.form-group, .field, .mtx-field, .file-upload-wrapper') || f.parentElement;
        var hint = wrap && wrap.querySelector('label, .form-label, .upload-text, legend');
        name = hint ? (hint.innerText || hint.textContent || '').replace(/\s+/g, ' ').trim() : '';
      }
      if (!name && f.name) name = f.name.replace(/[_\-\[\]]+/g, ' ').trim();
      if (name) f.setAttribute('aria-label', name.slice(0, 120));
    });
    root.querySelectorAll('form [class*="error"], .mtx-error, .errors').forEach(function (e) {
      if (e.getAttribute('role') || /^(INPUT|SELECT|TEXTAREA|LABEL|FORM)$/.test(e.tagName) || e.querySelector('input, select, textarea, button')) return;
      e.setAttribute('role', 'alert');
    });
    root.querySelectorAll('.form-success, .mtx-success, [class*="success-message"]').forEach(function (e) { if (!e.getAttribute('role')) e.setAttribute('role', 'status'); });
  }

  /* App widgets (reviews, chat): readable grey labels and a visible keyboard focus ring. Their own code is not changed. */
  function widgetA11y() {
    var st = document.createElement('style');
    st.textContent = '.jdgm-rev__timestamp,.jdgm-rev__location,.jdgm-prev-badge__text,.jdgm-rev-widg__summary-text{color:#5E5A52!important}' +
      '.jdgm-widget a:focus-visible,.jdgm-widget button:focus-visible,.jdgm-widget [tabindex]:focus-visible,' +
      '#meri-ai-chat-root button:focus-visible,#meri-ai-chat-root a:focus-visible,#meri-ai-chat-root input:focus-visible,#meri-ai-chat-root textarea:focus-visible' +
      '{outline:2px solid #1A1917!important;outline-offset:2px!important}';
    document.head.appendChild(st);
  }

  function init() {
    document.querySelectorAll('.mt-hero').forEach(function (h) {
      watch(h, '.mt-hero__slide', function (el) { return el.classList.contains('mt-active'); });
    });
    document.querySelectorAll('[data-mt-tabs]').forEach(function (t) {
      watch(t, '.mt-tabpanel', function (el) { return !el.hidden; });
    });
    collectionDescription();
    clickablePhotos();
    widgetA11y();
    formsA11y();
    /* forms that are drawn later (pop-ups, steps of a form) are picked up too */
    setTimeout(formsA11y, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();